import { ReactElement, useEffect, useState } from "react"
import { useLocalStorage } from "shared/localstorage_helper"
import logIFTTTNextAction from "app/lib/ifttt_next_log_action"
import XIcon from "shared/components/icons/x_icon"

import "./index.scss"

const storageId = "promoteAppBanner"

export const validTimeframe = (state: { lastClosed: number }) => {
  const lastClosed = state.lastClosed
  const currentTime = new Date().getTime()
  const diff = currentTime - lastClosed
  const hoursDifference = Math.floor(diff / 1000 / 60 / 60)

  return hoursDifference >= 24
}

const checkLastClosed = (state: { lastClosed: number }) => {
  if (!state.lastClosed) return true
  return validTimeframe(state)
}

const formatURL = () => {
  let url = window.location.href

  if (!url) {
    url = "https://ifttt.com"
  } else if (url.match(/return_to=/gi)) {
    url = url.split("?return_to=")[1]
  }

  return url
}

const PromoteAppBanner = ({
  mobileDevice,
  userId,
}: {
  mobileDevice: "ios" | "android" | "none"
  userId: string | null
}): ReactElement | null => {
  const [bannerState, setBannerState] = useLocalStorage(userId ? `${storageId}-${userId}` : storageId, {
    lastClosed: null,
  })
  const [showBanner, setShowBanner] = useState(checkLastClosed(bannerState))

  const url = formatURL()
  const bannerCopy = "Get the full IFTTT experience in the app"

  useEffect(() => {
    showBanner &&
      logIFTTTNextAction("page_viewed", {
        object_type: "promote_app_banner",
        location_type: "promote_app_banner",
      })
  }, [])

  if (mobileDevice === "none" || window.screen.width > 770) return null

  const handleClose = () => {
    logIFTTTNextAction("click", {
      object_type: "promote_app_banner_close",
      object_id: mobileDevice,
      location_type: "promote_app_banner",
    })
    setBannerState({ lastClosed: new Date().getTime() })
    setShowBanner(false)
  }

  const downloadOrOpenApp = (os: string) => {
    logIFTTTNextAction("click", {
      object_type: "promote_app_banner_link",
      object_id: os,
      location_type: "promote_app_banner",
    })
    setBannerState({ lastClosed: new Date().getTime() })
    setShowBanner(false)
  }

  return (
    showBanner && (
      <div styleName="promote-app-container">
        <div styleName="promote-app-background"></div>
        <div styleName="promote-app-content">
          <div styleName="close" onClick={handleClose}>
            <XIcon width="24" height="24" color="#FFF" />
          </div>
          <div styleName="promote-app-title">{bannerCopy}</div>
          <a
            role="button"
            className="button-tertiary button-on-color"
            styleName="button-tertiary"
            href={`https://ifttt.page.link/?link=${url}&apn=com.ifttt.ifttt&ibi=com.ifttt.ifttt&isi=660944635`}
            title="Download or Open the app"
            aria-label="Download or Open the app"
            onClick={() => downloadOrOpenApp(mobileDevice)}
          >
            Open
          </a>
        </div>
      </div>
    )
  )
}

export default PromoteAppBanner
